import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChange,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {
  NgxBlocklyComponent,
  NgxBlocklyConfig,
  NgxBlocklyGeneratorConfig,
} from 'ngx-blockly';
import { ApplicationService } from 'src/app/shared/services/application.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import * as BlocklyNew from 'ngx-blockly';
import { UserSessionService } from '../../services/user.session.service';
import { SessionStorageService } from '../../services/session-storage.service';
import { ToastrService } from 'ngx-toastr';
import { BlockComparisonResult } from '../../models/block';
import { SupportedCodeLang } from '../../domain/code-gen/code-lang.types';
import { getCodeLangConfig } from '../../domain/code-gen/code-lang.utils';
import { CodeGeneratorService } from '../../services/code-generator.service';
import { LoaderService } from '../../services/loader.service';

declare const createTypedFlyoutCallback: any;

@Component({
  selector: 'app-blockly',
  templateUrl: './blockly.component.html',
  styleUrls: ['./blockly.component.scss'],
})
export class BlocklyComponent implements OnInit, OnChanges {
  @Input() codeLang!: SupportedCodeLang;
  @Input() ieeeEvent: any;
  @Input() nielitEvent: boolean = false;
  @Input() toggle: any;
  @Input() sizeChanged: any;
  @Input() selectedApplication: any;
  @Input() applicationIdentifier!: string;
  @Input() toolbox: string = '';
  @Input() isReadOnly: boolean = false;
  @Input() isAdmin: boolean = false;
  @Input() isBlock: boolean = true;
  @Input() parentComponent: string = BlocklyComponent.name;
  @Output() emitGeneratedCode = new EventEmitter();
  @Output() emitXMLEvent = new EventEmitter();
  @Output() isBlockWithSimulator = new EventEmitter();
  @Output() tutorials = new EventEmitter();
  @Output() moduleNameEmitter = new EventEmitter();
  @Output() videoTutorial = new EventEmitter();
  @Output() applicationdata = new EventEmitter();
  
  // Block comparison variables
  isCompareRequested: boolean = false;
  @Input() isCompareResult: BlockComparisonResult = BlockComparisonResult.Default;
  @Output() leftBlockCodeEmitter = new EventEmitter();
  @Output() compareBlockEmitter = new EventEmitter();
  @Output() resetCompareBlockResultEmitter = new EventEmitter();

  toggleBtnState: boolean = false;
  disableToggleBtn: boolean = false;
  isNotebook: boolean = false;
  // application!: any;
  moduleName!: string;
  notebook_url!: SafeUrl;
  notebook_download_url!: SafeUrl;
  notebook_download_name!: string;
  tutorialData: any;
  video: boolean = false;
  isVideoBtn: boolean = false;
  localStorageKeyWithMobile!: string;
  localStorageKeyWithoutMobile!: string;
  alternateKeyWithMobile!: string;
  alternateKeyWithoutMobile!: string;
  isTemplate: boolean;
  isDesktopOpened: boolean = false;

  private workspaceInitialized: boolean = false;
  private hasBlockContent = false;
  @ViewChild(NgxBlocklyComponent, { static: false }) public workspace!: NgxBlocklyComponent;

  xml!: any;

  private theme = Blockly.Theme.defineTheme(
    `ide-theme-${Math.floor(100000000 + Math.random() * 900000000)}`,
    {
      base: Blockly.Themes.Classic,
      blockStyles: {
        colour_blocks: {
          colourPrimary: '#CF63CF',
          colourSecondary: '#C94FC9',
          colourTertiary: '#BD42BD',
        },
        list_blocks: {
          colourPrimary: '#9966FF',
          colourSecondary: '#855CD6',
          colourTertiary: '#774DCB',
        },
        logic_blocks: {
          colourPrimary: '#4C97FF',
          colourSecondary: '#4280D7',
          colourTertiary: '#3373CC',
        },
        loop_blocks: {
          colourPrimary: '#0fBD8C',
          colourSecondary: '#0DA57A',
          colourTertiary: '#0B8E69',
        },
        math_blocks: {
          colourPrimary: '#59C059',
          colourSecondary: '#46B946',
          colourTertiary: '#389438',
        },
        procedure_blocks: {
          colourPrimary: '#FF6680',
          colourSecondary: '#FF4D6A',
          colourTertiary: '#FF3355',
        },
        text_blocks: {
          colourPrimary: '#FFBF00',
          colourSecondary: '#E6AC00',
          colourTertiary: '#CC9900',
        },
        variable_blocks: {
          colourPrimary: '#FF8C1A',
          colourSecondary: '#FF8000',
          colourTertiary: '#DB6E00',
        },
        variable_dynamic_blocks: {
          colourPrimary: '#FF8C1A',
          colourSecondary: '#FF8000',
          colourTertiary: '#DB6E00',
        },
        hat_blocks: {
          colourPrimary: '#4C97FF',
          colourSecondary: '#4280D7',
          colourTertiary: '#3373CC',
          hat: 'cap',
        },
      },
      categoryStyles: Blockly.Themes.Modern,
      componentStyles: {
        workspaceBackgroundColour: '#fff',
        toolboxBackgroundColour: '#fff',
        toolboxForegroundColour: '#324d67',
        flyoutBackgroundColour: '#fff1f5ad',
        flyoutForegroundColour: '#ccc',
        flyoutOpacity: 1,
        scrollbarColour: '#fff',
        insertionMarkerColour: '#000',
        insertionMarkerOpacity: 0.3,
        scrollbarOpacity: 0.2,
        cursorColour: '#d0d0d0',
        blackBackground: '#333',
      },
      fontStyle: Blockly.Themes.Modern,
      startHats: true,
    }
  );

  private themeForPredefined = Blockly.Theme.defineTheme(
    `predef-theme-${Math.floor(100000000 + Math.random() * 900000000)}`,
    {
      base: Blockly.Themes.Classic,
      blockStyles: {
        colour_blocks: {
          colourPrimary: '#CF63CF',
          colourSecondary: '#C94FC9',
          colourTertiary: '#BD42BD',
        },
        list_blocks: {
          colourPrimary: '#9966FF',
          colourSecondary: '#855CD6',
          colourTertiary: '#774DCB',
        },
        logic_blocks: {
          colourPrimary: '#4C97FF',
          colourSecondary: '#4280D7',
          colourTertiary: '#3373CC',
        },
        loop_blocks: {
          colourPrimary: '#0fBD8C',
          colourSecondary: '#0DA57A',
          colourTertiary: '#0B8E69',
        },
        math_blocks: {
          colourPrimary: '#59C059',
          colourSecondary: '#46B946',
          colourTertiary: '#389438',
        },
        procedure_blocks: {
          colourPrimary: '#FF6680',
          colourSecondary: '#FF4D6A',
          colourTertiary: '#FF3355',
        },
        text_blocks: {
          colourPrimary: '#FFBF00',
          colourSecondary: '#E6AC00',
          colourTertiary: '#CC9900',
        },
        variable_blocks: {
          colourPrimary: '#FF8C1A',
          colourSecondary: '#FF8000',
          colourTertiary: '#DB6E00',
        },
        variable_dynamic_blocks: {
          colourPrimary: '#FF8C1A',
          colourSecondary: '#FF8000',
          colourTertiary: '#DB6E00',
        },
        hat_blocks: {
          colourPrimary: '#4C97FF',
          colourSecondary: '#4280D7',
          colourTertiary: '#3373CC',
          hat: 'cap',
        },
      },
      categoryStyles: Blockly.Themes.Modern,
      componentStyles: {
        workspaceBackgroundColour: 'transparent',
        scrollbarColour: '#fff',
        insertionMarkerOpacity: 0.3,
        scrollbarOpacity: 0.2,
        cursorColour: '#d0d0d0',
        blackBackground: '#333',
      },
      fontStyle: Blockly.Themes.Modern,
      startHats: true,
    }
  );

  code: string = '';

  public config: NgxBlocklyConfig = {
    move: {
      scrollbars: true,
      drag: true,
      wheel: false,
    },
  };

  public generatorConfig: NgxBlocklyGeneratorConfig = {
    dart: false,
    javascript: false,
    lua: false,
    php: false,
    python: false,
    xml: false,
  };

  public blockly: any;
  constructor(
    private applicationService: ApplicationService,
    private domSanitizer: DomSanitizer,
    private userSessionService: UserSessionService,
    private sessionStorageService: SessionStorageService,
    private toasterService: ToastrService,
    private codeGenService: CodeGeneratorService,
    private loaderService: LoaderService,
  ) {
    this.isTemplate = window.location.href.includes('template');
  }

  async ngOnInit() {
    this.blockly = Blockly;
    this.initCodeGenerator();
    if (!this.applicationIdentifier && this.isReadOnly) {
      this.getTemplate();
    }
    this.setLocalStorageKeys();
    if (!window.location.href.includes('nielit')) {
      await this.userSessionService.extendToken(this.sessionStorageService.getUsername()).toPromise();
    }  
  }

  private setAlternateKeys() {
    this.alternateKeyWithMobile = this.localStorageKeyWithMobile.replace("edit", "create");
    this.alternateKeyWithoutMobile = this.localStorageKeyWithoutMobile.replace("edit", "create");
  }

  private getAlternateKey() {
    const alternateKey = this.toggleBtnState ? this.alternateKeyWithMobile : this.alternateKeyWithoutMobile;
    return alternateKey;
  }

  setLocalStorageKeys() {
    const isCreate = window.location.href.includes("/create");
    const isEdit = window.location.href.includes("/edit/") || window.location.href.includes("/ieee/");
    const isWorkarea = window.location.href.includes("/ide/");
    const keyPrefix = "blocklyXML";
    const isBlocklySection = this.parentComponent === 'BlocklySectionComponent';
    const platformType = isBlocklySection ? this.isAdmin ? "admin" : "ide" : null;
    const ieeePlatform = "admin"
    const isDirect = window.location.href.includes("block-direct");
    const isAdminBlock = window.location.href.includes("/admin/block");
    const app_id = isBlocklySection ? this.isAdmin ? null : sessionStorage.getItem('app_id') : null;

    const codeLangPrefix = getCodeLangConfig(this.codeLang)?.storagePrefix || '';


    let blockSectionIdentifier = '';

    if (this.applicationIdentifier) {
      let keyType = 'unknown';
      if (isEdit) { keyType = "edit"; }
      else if (isCreate) { keyType = "create"; } //create flow is triggered just once; upon exiting midway we will enter edit flow
      else if (isWorkarea) { keyType = "workarea"; }

      blockSectionIdentifier = `${keyType}-${this.applicationIdentifier}`;
    }
    else if (isDirect) blockSectionIdentifier = 'direct';
    else if (isAdminBlock) blockSectionIdentifier = 'admin-block';
    else if (app_id) {
      let keyType = 'unknown';
      if (isWorkarea) { keyType = "workarea"; }
      blockSectionIdentifier = `${keyType}-${app_id}`;
    }
    if (this.ieeeEvent) {
      this.localStorageKeyWithMobile = `${keyPrefix}-${ieeePlatform}-withMobile-${codeLangPrefix}${blockSectionIdentifier}`;
      this.localStorageKeyWithoutMobile = `${keyPrefix}-${ieeePlatform}-withoutMobile-${codeLangPrefix}${blockSectionIdentifier}`;
    } else if (blockSectionIdentifier) {
      this.localStorageKeyWithMobile = `${keyPrefix}-${platformType}-withMobile-${codeLangPrefix}${blockSectionIdentifier}`;
      this.localStorageKeyWithoutMobile = `${keyPrefix}-${platformType}-withoutMobile-${codeLangPrefix}${blockSectionIdentifier}`;
      if (isEdit) { this.setAlternateKeys(); }
    }
  }

  getLocalStorageKey() {
    const localStorageKey = this.toggleBtnState ? this.localStorageKeyWithMobile : this.localStorageKeyWithoutMobile;
    return localStorageKey;
  }

  async ngAfterViewInit(): Promise<void> {
    try {
      await window.__blocklyLoaded;
      this.setXml(this.ngAfterViewInit.name);
    } catch (error) {
      console.error('Blockly failed to initialize:', error);
    }
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    const { toolbox, isReadOnly, codeLang, applicationIdentifier, isCompareResult } = changes;

    const hasToolboxChanged = toolbox && !toolbox.firstChange && toolbox.currentValue;
    const hasCodeLangChanged = codeLang?.previousValue !== undefined &&
      codeLang.previousValue !== codeLang.currentValue;

    if (hasCodeLangChanged) {
      this.handleCodeLangChange(codeLang.currentValue);
    }

    if (applicationIdentifier?.currentValue) {
      this.getTemplate(this.applicationIdentifier);
    }

    if (isCompareResult?.currentValue && this.isCompareRequested) {
      await this.comparisonResult();
      this.resetCompareBlockResultEmitter.emit({});
    } else if (!isCompareResult) {
      // Only handle selected application when isCompareResult is NOT the changing input
      this.handleSelectedApplication();
    }

    if (this.toolbox && (
      isReadOnly !== undefined ||
      hasToolboxChanged ||
      !this.workspaceInitialized
    )) {
      this.configureWorkspace(isReadOnly);
    }

  }

  private handleCodeLangChange(updatedCodeLang: SupportedCodeLang): void {
    this.initCodeGenerator();
    this.setLocalStorageKeys();
    this.emitGeneratedCode.emit('');
  }

  private async handleSelectedApplication(): Promise<void> {
    if (this.selectedApplication?.appUserID || this.selectedApplication?.applicationIdentifier) {
      await window.__blocklyLoaded;
      this.setXml(this.ngOnChanges.name);
    } else if (this.selectedApplication === '') {
      this.workspace?.clear();
    }
  }

  private configureWorkspace(isReadOnlyChange?: SimpleChange): void {
    if (!this.toolbox) {
      return;
    }

    const isReadOnlyValue = isReadOnlyChange?.currentValue ?? this.isReadOnly;

    if (isReadOnlyValue) {
      this.setupPreBuild();
      try {
        Blockly.ContextMenuRegistry?.registry?.unregister('workspaceDelete');
      } catch (e) { }
      Blockly.Flyout.prototype.dragAngleRange_ = 360;
    } else {
      this.setupWorkplace();
      Blockly.Flyout.prototype.dragMode_ = Blockly.DRAG_STICKY;
    }

    if (!isReadOnlyChange) {
      this.applyThemeToWorkspace();
    }

    this.workspaceInitialized = true;
  }

  private applyThemeToWorkspace(): void {
    const nativeWs = this.workspace?.workspace;
    if (!nativeWs) return;

    try {
      const theme = this.isReadOnly ? this.themeForPredefined : this.theme;
      nativeWs.setTheme(theme);
      nativeWs.render();
    } catch (error) {
    }
  }

  private setupPreBuild(): void {
    this.config = {
      ...this.config,
      toolbox: this.toolbox,
      zoom: { startScale: 0.9 },
      theme: this.themeForPredefined,
      trashcan: false,
      css: true,
    };
  }

  private setupWorkplace(): void {
    this.config = {
      ...this.config,
      toolbox: this.toolbox,
      zoom: {
        controls: false, //to show zoom in & zoomout buttons
        wheel: false,
        startScale: 0.9,
        maxScale: 3,
        minScale: 0.5,
        scaleSpeed: 1.2,
      },
      readOnly: false,
      scrollbars: true,
      trashcan: false, // for trash can or delete
      grid: { spacing: 20, length: 3, colour: '#ccc', snap: true },
      theme: this.theme,
    };
  }

  reloadAPICall() {
    if (window.location.href.includes('nielit')) {
      setTimeout(() => {
        this.toasterService.warning("Reloading the blocks...");
        this.getTemplate();
      }, 2000)
    }
  }

  private initCodeGenerator(): void {
    this.codeLang = "python"
    const codeGeneratorName = getCodeLangConfig(this.codeLang)?.generatorName?.toLowerCase();

    Object.keys(this.generatorConfig).forEach(key => {
      this.generatorConfig[key as keyof NgxBlocklyGeneratorConfig] = (key === codeGeneratorName);
    });
  }

  onWorkspaceChange(event: Event): void {
    this.regenerateAndEmitCode();
  }

  /**
   * Forces code regeneration from the current workspace state.
   * Commits any open field editors first.
   */
  public forceRegenerateCode(): void {
    const workspace = this.workspace?.workspace;
    if (!workspace) return;

    // Force-close any open field editors to commit pending values
    try {
      if (Blockly.WidgetDiv?.isVisible?.()) {
        Blockly.WidgetDiv.hide();
      } else if (Blockly.WidgetDiv) {
        Blockly.WidgetDiv.hide();
      }
    } catch (e) {}

    // Small delay to allow the field commit event to propagate
    setTimeout(() => this.regenerateAndEmitCode(), 50);
  }

  private regenerateAndEmitCode(): void {
    const workspace = this.workspace?.workspace;
    if (!workspace) return;

    try {
      this.createXML();
      this.codeLang = "python";
      const generatedCode = this.codeGenService.generateCode(this.codeLang, workspace);
      this.emitGeneratedCode.emit(generatedCode);
      this.emitLeftBlock();
    } catch (error) {
    }
  }

  private async getTemplate(id?: string) {
    if(this.ieeeEvent || window.location.href.includes('nielit')){
      this.isBlock = true;
    }

    const app_id: any = id || sessionStorage.getItem('app_id');
    let data: any;
    try {
      this.loaderService.show();
      if (this.isAdmin) {
        data = await this.applicationService
          .getApplicationTemplateV3(app_id);
      } else {
        if (this.isBlock) {
          data = await this.applicationService
            .getApplicationTemplateV3(app_id);
        } else {
          data = await this.applicationService
            .getApplication(app_id)
            .toPromise();
        }
      }
      this.loaderService.hide();
      if (data) {
        this.applicationdata.emit({ data: data });
        this.selectedApplication = data.Application;
        this.updateData();
        this.tutorialData = this.selectedApplication;
        this.ifTutorialData(this.selectedApplication); //get tutorial video urls
      }
    } catch (error: any) {
      this.loaderService.hide();
      this.disableToggleBtn = true;
      console.log(error);
      this.toasterService.error(error?.error?.message || error?.message || 'Error fetching application data');
      if (error.status == 0) {
        this.reloadAPICall();
      }
    }
  }

  private async updateData() {
    await window.__blocklyLoaded;
    this.moduleName = this.selectedApplication?.moduleName;
    this.updateNotebookLink();
    this.tutorials.emit(this.selectedApplication?.tutorials);
    this.moduleNameEmitter.emit(this.moduleName);
    this.setXml(this.updateData.name);
  }

  private updateNotebookLink(): void {
    if (this.selectedApplication.applicationIdentifier) {
      const url =
        '/assets/notebooks/' + this.selectedApplication.applicationIdentifier;
      this.notebook_url = this.domSanitizer.bypassSecurityTrustResourceUrl(
        url + '.html'
      );
      this.notebook_download_name =
        this.selectedApplication.applicationName + '.ipynb';
      this.notebook_download_url =
        this.domSanitizer.bypassSecurityTrustResourceUrl(url + '.ipynb');
    }
  }

  downloadNotebook() { }

  private setXml(access: string) {
    const applicationDefinition =
      this.selectedApplication?.applicationDefinition;
    const toolboxDefinition = this.selectedApplication?.toolboxDefinition;

    let localStorageXml = this.loadExistingWorkspace();
    if (localStorageXml) {
      this.updateXml(localStorageXml, `${this.setXml.name}-${access}-localStorage`);
    } else {
      if (this.toggleBtnState) {
        this.updateXml(applicationDefinition, `${this.setXml.name}-${access}-applicationDefinition`);
      } else {
        this.updateXml(toolboxDefinition, `${this.setXml.name}-${access}-toolboxDefinition`);
      }
    }
    this.setupBasicCode();
  }

  private setupBasicCode() {
    if (!this.workspace) {
      return;
    }

    if (!this.xml) {
      this.workspace.clear();
      return;
    }

    this.workspace.toXml();
    const parsed = this.parseXMLForPosition(this.xml);
    if (parsed) {
      this.workspace.fromXml(parsed);
    }
  }

  private createXML() {
    const xml = this.workspace.toXml();
    const localStorageKey = this.getLocalStorageKey();
    if (localStorageKey) this.saveXMLToLocalStorage();
    this.emitXMLEvent.emit(xml);
  }

  saveXMLToLocalStorage() {
    const xml = this.workspace.toXml();
    const localStorageKey = this.getLocalStorageKey();
    if (!localStorageKey) return;

    const isEmpty = xml === `<xml xmlns="https://developers.google.com/blockly/xml"></xml>`;

    if (!isEmpty) {
      localStorage.setItem(localStorageKey, xml);
      this.hasBlockContent = true;
    } else if (this.hasBlockContent) {
      localStorage.removeItem(localStorageKey);
    }
  }

  restoreXMLFromLocalStorage(): any {
    const localStorageKey = this.getLocalStorageKey();
    const alternateKey = this.getAlternateKey();
    let xml;
    let alternateXml;
    let localXml;
    if (localStorageKey) {
      localXml = localStorage.getItem(localStorageKey) as string;
    }
    if (alternateKey) {
      alternateXml = localStorage.getItem(alternateKey) as string;
      if (alternateXml) localStorage.removeItem(alternateKey);
    }
    xml = localXml ? localXml : alternateXml;
    return xml;
  }

  loadExistingWorkspace() {
    if (!this.workspace) return;
    const localStorageXml = this.restoreXMLFromLocalStorage();
    return localStorageXml;
  }

  onCode(code: string) {
    this.emitGeneratedCode.emit(code);
    this.createXML();
    this.emitLeftBlock();
  }

  private parseXMLForPosition(xmlString: string) {
    const domParser = new DOMParser();
    const parsedXML = domParser.parseFromString(xmlString, 'text/xml');
    const element = parsedXML.getElementsByTagName('block');
    // element[0]?.setAttribute('x', '98');
    // element[0]?.setAttribute('y', '20');

    const serializer = new XMLSerializer();
    const xmlStr = serializer.serializeToString(parsedXML);
    return xmlStr;
  }

  reload() {
    if (!this.isReadOnly) {
      return;
    }
    this.getTemplate();
  }

  toggleState() {
    this.toggleBtnState = !this.toggleBtnState;
    this.setXml(this.toggleState.name);
    this.isBlockWithSimulator.emit(this.toggleBtnState);
  }

  toggleNotebook() {
    this.isNotebook = !this.isNotebook;
    if (!this.isNotebook) this.reload();
  }

  ifTutorialData(data: any) {
    if (data?.tutorials?.block || data?.tutorials?.default) {
      //checking if url include vimeo or youtube
      let tutorialUrl = data.tutorials?.block || data.tutorials?.default;
      if (tutorialUrl.includes('youtube') || tutorialUrl.includes('vimeo')) {
        this.isVideoBtn = true;
      }
      else {
        this.isVideoBtn = false;
      }
    } else {
      this.isVideoBtn = false;
    }
  }

  videoPlay() {
    this.video = !this.video;
    this.videoTutorial.emit({
      isVideo: this.video,
      isData: this.selectedApplication,
    });
  }

  // compareBlock() {
  //   this.isCompareTriggered = true;
  //   let leftBlock = this.workspace.workspace.getAllBlocks(true);
  //   this.compareBlocks.emit({
  //     isCompare: true,
  //     leftBlock: leftBlock
  //   })
  // }

  public getBlocks(): BlocklyNew.Block[] {
    return this.workspace.workspace.getAllBlocks(true);
  }

  private updateXml(xml: string, calledFrom: string) {
    this.xml = xml;
  }

  async emitLeftBlock(event?: any) {
    let leftBlock = this.workspace.workspace.getAllBlocks(true);
    await this.leftBlockCodeEmitter.emit({ leftBlock })
  }

  async emitCompareBlock(event?: any) {
    this.isCompareRequested = true;
    await this.compareBlockEmitter.emit({});
  }

  async comparisonResult() {
    if (this.isCompareResult === BlockComparisonResult.Success) {
      this.toasterService.success("There are no differences found between the reference diagram and work diagram");
    }
    // else if (this.isCompareResult === BlockComparisonResult.Error) {
    //   // this.toasterService.error("Blocks Mismatched");
    // }

    // Resetting flags
    this.isCompareResult = BlockComparisonResult.Default;
    this.isCompareRequested = false;
  }
}